const $ = require('../sukoa-jquery.cjs');
const sukoaUtils = require('../sukoaUtils').default;
function List($list) {
    this.$list = $list;
    this.$elementsWrapper = this.$list.find(".list-wrapper");
    if(!this.$elementsWrapper) {
        return null;
    }
    this.elementsWrapperTopOffset = this.$elementsWrapper.offset().top;
    this.elementsWrapperLeftOffset = this.$elementsWrapper.offset().left;
    this.elementsWrapperHeight = this.$elementsWrapper.outerHeight(true);
    this.elementsWrapperWidth = this.$elementsWrapper.outerWidth(true);
    this.$elements = this.$elementsWrapper.find(".filterable");
    this.$filters = this.$list.find(".filter");
    this.$noresult = $("#noResult");
    this.$glimpsedisplay = $("#showthumbnails");
    this.$listdisplay = $("#showlist");
    this.currentDisplay = "thumbnails";
    this.newFreePlaces = [];
    this.lastFreePlaceIndex = 0;
    this.restaureElemWrapperSizeTimer = null;
    this.resizeTO = null;
    this.filtersState = [];
    this.elementsState = [];
    this.searchInput = document.querySelector('.input-field');
    this.noProjectsFound = document.getElementById('no-projects-found');
}

List.prototype.displayList = function() {
    this.updateDisplay("thumbnails", "list");
    this.updateUrl();
    this.$glimpsedisplay.removeClass("active");
    this.$listdisplay.addClass("active");
};

List.prototype.displayGlimpse = function() {
    this.updateDisplay("list", "thumbnails");
    this.updateUrl();
    this.$listdisplay.removeClass("active");
    this.$glimpsedisplay.addClass("active");
};

List.prototype.updateDisplayListener = function() {
    let self = this;
    this.$glimpsedisplay.click(function(){
        self.displayGlimpse();
    });

    this.$listdisplay.click(function(){
        self.displayList();
    });
};

List.prototype.updateDisplay = function(currentDisplayClass, newDisplayClass) {
    if(this.currentDisplay !== newDisplayClass) {
        this.$elementsWrapper.removeClass(currentDisplayClass).addClass(newDisplayClass);
        this.currentDisplay = newDisplayClass;
    }
};

List.prototype.resetFilters = function() {
    for(let f in this.filtersState) {
        this.filtersState[f].resetme();
    }
};

List.prototype.activate = function () {
    this.$elementsWrapper.css({
        height: this.elementsWrapperHeight+"px"
    });
    this.applyUrlParameters();
    this.updateDisplayListener();
    let self = this;
    $(window).resize(function(){
        if(self.currentDisplay !== "list") {
            self.releaseElementsWrapper();
        }
    });
};

List.prototype.countActiveFilters = function() {
    let activeFilters = 0;
    for(let f in this.filtersState) {
        if(this.filtersState[f].isActive()) {
            activeFilters++;
        }
    }

    return activeFilters;
};

List.prototype.applyUrlParameters = function() {
    let viewParam = sukoaUtils.getParameterByName("view");
    let urlParam = sukoaUtils.getParameterByName("filter");
    let searchParam = sukoaUtils.getParameterByName("search");

    if(urlParam !== "" || searchParam !== "") {
        $("body").animate({scrollTop:this.$list.offset().top+"px"}, 700);
        let params = urlParam.split("+");
        for(let f in this.filtersState) {
            this.filtersState[f].updateFromUrlParams(params);
        }
        this.applyFilters(false);
    }
    if(viewParam === "list") {
        this.displayList();
    }
};

List.prototype.updateUrl = function() {
    let params = "";
    for (let f in this.filtersState) {
        if(this.filtersState[f].isActive()) {
            if(this.filtersState[f].isSelect()) {
                if(params !== "") {
                    params += "%2b";
                }
                params += this.filtersState[f].idsLabelsTab[this.filtersState[f].activeValues];
            } else if(!this.filtersState[f].isSearch()){
                for(let av in this.filtersState[f].activeValues) {
                    if(params !== "") {
                        params += "%2b";
                    }
                    params += this.filtersState[f].idsLabelsTab[this.filtersState[f].activeValues[av]];
                }
            }
        }
    }

    if(params !== "") {
        params = "?filter=" + params;
    }

    const searchInputValue = (this.searchInput.value || '').trim().toLowerCase();
    if (searchInputValue) {
        params += (params.indexOf('?') === -1 ? '?search=' : '&search=') + encodeURIComponent(searchInputValue);
    }

    if(params.indexOf("?") === -1) {
        params = "?view=" + this.currentDisplay;
    } else {
        params += "&view=" + this.currentDisplay;
    }

    let url = sukoaUtils.getCurrentURL(true) + params;
    if(history.pushState) {
        history.pushState(null, null, url);
    }
};

List.prototype.fixeElementsWrapper = function() {
    if(!this.$elementsWrapper.hasClass("fixed")){
        this.$elementsWrapper.addClass("fixed");
        this.$elementsWrapper.css("height", this.elementsWrapperHeight+"px");
    }
};

List.prototype.releaseElementsWrapper = function() {
    this.$elementsWrapper.removeClass("fixed");
    this.$elementsWrapper.css({"height": "auto"});
    if(this.elementsWrapperWidth !== this.$elementsWrapper.outerWidth(true)) {
        this.elementsWrapperTopOffset = this.$elementsWrapper.offset().top;
        this.elementsWrapperLeftOffset = this.$elementsWrapper.offset().left;
        this.elementsWrapperWidth = this.$elementsWrapper.outerWidth(true);
        this.resetAllPositions();
    }
};

List.prototype.resetAllPositions = function() {
    this.$elements.addClass("resetposition");
    for(let e in this.elementsState) {
        this.elementsState[e].calculatePosition();
        this.elementsState[e].originalPosition = this.elementsState[e].getCurrentPositionCss();
    }
    this.elementsWrapperHeight = this.$elementsWrapper.outerHeight(true);
    this.$elements.removeClass("resetposition");
};

List.prototype.executeElementsActions = function() {
    let maxTop = 0;
    this.newFreePlaces = [];
    this.lastFreePlaceIndex = 0;
    for(let e in this.elementsState) {
        if(this.elementsState[e].nextAction === "hideMe") {
            this.newFreePlaces.push(this.elementsState[e].getCurrentPositionCss());
            this.elementsState[e].hideMe();

        } else if(this.elementsState[e].nextAction === "transfertMe") {
            if(this.newFreePlaces.length === 0 || this.newFreePlaces.length <= this.lastFreePlaceIndex){
                this.elementsState[e].transfertMe(this.elementsState[e].originalPosition);
                maxTop = this.elementsState[e].top;

            } else {
                this.newFreePlaces.push(this.elementsState[e].getCurrentPositionCss());
                this.elementsState[e].transfertMe(this.newFreePlaces[this.lastFreePlaceIndex]);
                maxTop = 1 * this.newFreePlaces[this.lastFreePlaceIndex].top.replace("px","");
                this.lastFreePlaceIndex++;

            }
        } else if(this.elementsState[e].nextAction === "showMe"){
            if(this.newFreePlaces.length === 0 || this.newFreePlaces.length <= this.lastFreePlaceIndex){
                this.elementsState[e].showMe(this.elementsState[e].originalPosition);
                maxTop = this.elementsState[e].top;
            } else {
                this.newFreePlaces.push(this.elementsState[e].getCurrentPositionCss());
                this.elementsState[e].showMe(this.newFreePlaces[this.lastFreePlaceIndex]);
                maxTop = 1 * this.newFreePlaces[this.lastFreePlaceIndex].top.replace("px","");
                this.lastFreePlaceIndex++;
            }
        } else {
            this.newFreePlaces.push(this.elementsState[e].getCurrentPositionCss());
        }

    }
    maxTop = Math.round(maxTop+500);
    //this.$elementsWrapper.css("height", maxTop+"px");
    this.$elementsWrapper.animate({height:maxTop+"px"}, "slow");

};

List.prototype.updateFiltersOptions = function(usedTags) {
    if(this.filtersState.length > 1) {
        for(let f in this.filtersState) {
            this.filtersState[f].updateOptions(usedTags);
        }
    }
    if(usedTags.length > 1) {
        this.noProjectsFound.classList.add("hidden");
    }
    else {
        // Adding timeout to prevent showing text before projects disappeared
        setTimeout(() => {
            this.noProjectsFound.classList.remove("hidden");
        }, 500);
    }
};

List.prototype.applyFilters = function (updateUrl) {
    this.fixeElementsWrapper();
    if(typeof updateUrl === typeof undefined || updateUrl) {
        this.updateUrl();
    }
    let usedTags = ["0"];
    //let displayAll = true;
    for (let e in this.elementsState) {
        if(this.elementsState[e].filterme(this.filtersState)){
            for(let c in this.elementsState[e].categories){
                if(usedTags.indexOf(this.elementsState[e].categories[c]) === -1) {
                    usedTags.push(this.elementsState[e].categories[c]);
                }
            }
        }
    }


    this.updateFiltersOptions(usedTags);

    this.executeElementsActions();
};

export default List;
